import { FC, useContext, useState } from 'react';
import Select from 'react-select';
import { APP } from "../../Utils/Constants.ts";
import { DataPageContext } from "../../Context/DataPageContext.tsx";

interface TermOption {
  value: string | number | undefined;
  label: string;
  id: number;
}

interface TypeFormationProps {
  datas: Array<{
    attributes: {
      slug?: string;
      drupal_internal__tid: number;
      name: string;
    };
  }>;
  value: Filter | undefined;
  title: string;
  handleType: (filterId: string, e: any) => void;
}

const TypeFormation: FC<TypeFormationProps> = ({
  datas,
  value,
  title,
  handleType,
}) => {

  const { dataPage } = useContext(DataPageContext);
  const [menuOpen, setMenuOpen] = useState(false);

  // Native button for removing a selected item with full keyboard support
  const MultiValueRemove = (props: any) => {
    const { innerProps, data } = props;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        innerProps.onClick?.(e);
      }
    };

    return (
      <button
        type="button"
        {...innerProps}
        onKeyDown={handleKeyDown}
        aria-label={`Supprimer ${data.label}`}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '0 5px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        ×
      </button>
    );
  };

  // Native button for clearing all selected values with keyboard support
  const ClearIndicator = (props: any) => {
    const { innerProps, clearValue } = props;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        clearValue();
      }
    };

    return (
      <button
        type="button"
        {...innerProps}
        onKeyDown={handleKeyDown}
        aria-label="Vider le champ"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }}
      >
        ×
      </button>
    );
  };

  const getReactSelectValues = () => {
    const values: TermOption[] = [];

    value?.values.forEach((val: string | number | undefined) => {
      const terms = datas.filter((term) =>
        typeof val === 'string'
          ? term.attributes.slug === val
          : term.attributes.drupal_internal__tid === val
      );

      if (terms.length) {
        values.push(getTermOption(terms[0]));
      }
    });

    return values;
  };

  const getTermOption = (term: {
    attributes: {
      slug?: string;
      drupal_internal__tid: number;
      name: string;
    };
  }): TermOption => {
    return {
      value: term.attributes.slug,
      label: term.attributes.name,
      id: term.attributes.drupal_internal__tid
    };
  };

  const handleChange = (e: any) => {
    handleType(APP.FILTER.TYPE_FORMATION.FIELD, e);
    setMenuOpen(false);
  };

  // Handle keyboard interaction for opening the menu
  // Ignore events coming from internal buttons
  const handleKeyDown = (e: React.KeyboardEvent) => {
    const target = e.target as HTMLElement;

    if (target.closest('button')) return;

    if ((e.key === 'Enter' || e.key === ' ') && !menuOpen) {
      e.preventDefault();
      setMenuOpen(true);
    }
  };

  const options = () => {
    const acceptedId = dataPage === 'node-page-117'
      ? [100, 101, 159, 343]
      : [103, 106, 308];

    const allOptions = datas
      .map(getTermOption)
      .sort((a, b) => a.label.localeCompare(b.label));

    return allOptions.filter(option => acceptedId.includes(option.id));
  };

  return (
    <div className="filter-wrapper thematique-input">
      <label htmlFor="filter-type-formation" className="dropdown-list-label filter-label">
        {Drupal.t('Type de formation')}
      </label>

      <Select
        inputId="filter-type-formation"
        isDisabled={datas.length === 0}
        isMulti
        placeholder={title}
        onChange={handleChange}
        value={getReactSelectValues()}
        options={options()}

        menuIsOpen={menuOpen}
        onMenuOpen={() => setMenuOpen(true)}
        onMenuClose={() => setMenuOpen(false)}
        onKeyDown={handleKeyDown}

        components={{
          MultiValueRemove,
          ClearIndicator
        }}
      />
    </div>
  );
};

export default TypeFormation;
